module.exports = __webpack_public_path__ + "img/pci.2178f575.svg";